import { render, staticRenderFns } from "./documentos-comentarios.vue?vue&type=template&id=ee649236&scoped=true&"
import script from "./documentos-comentarios.component.ts?vue&type=script&lang=ts&"
export * from "./documentos-comentarios.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee649236",
  null
  
)

export default component.exports